function StatsCard({ title, value, icon, subtitle }) {
  return (
    <div className="stats-card">
      <div className="stats-card-content">
        <div className="stats-card-info">
          <p className="stats-card-label">{title}</p>
          <h3 className="stats-card-value">{value}</h3>
          {subtitle && <p className="stats-card-subtitle">{subtitle}</p>}
        </div>
        <div className="stats-card-icon" aria-hidden="true">{icon}</div>
      </div>
    </div>
  );
}

export default StatsCard;
